import React, {useContext, useRef, useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import Flag from 'react-world-flags'
import LoaderComp from 'components/base-components/loader'
import BaseButton from "components/base-components/base-button";
import Grow from "@material-ui/core/Grow";
import {Fade, Slide } from "@material-ui/core";
import {BreakPointContext} from 'contexts/breaking-point';
import countriesData from 'assets/data/country-data.json'
import { CountryContext } from '../../contexts/country-context';





const BottomSheet = ({ children, close, title }) => {
    const value = useContext(BreakPointContext)
    const [show, setShow] = useState(true)
   
 

    const className = "modals-wrapper"

   
    const _close = () => {
        setShow(false)

        setTimeout(function(){
            close()
        }, 200)
    }



    return (
        <>
            {!value.isMobile &&
                <Grow in={show} timeout={{ enter: 500, exit: 300}}>
                    <div className={className}>

                        <div className={className + '__header'}>

                            <BaseButton
                                className={"close-icon"}
                                icon={"cross"}
                                light
                                action={_close}
                            />
                        <div className={className + "__header__title"}> {title || " "}  </div>
                        
                       
                        </div>
                        <div className={className + '__body'}>
                            {children}
                        </div>
                    </div>
                </Grow>
            }

            {value.isMobile &&
            <Slide direction="up" in={show} mountOnEnter unmountOnExit>
                <div className={className}>

                    <div className={className + '__header'}>

                        <BaseButton
                            className={"close-icon"}
                            icon={"cross"}
                            light
                            action={_close}
                        />
                        <div className={className + "__header__title"}> {title}  </div>
                    </div>
                    <div  className={className + '__body'}>
                            {children}
                        </div>
                </div>
            </Slide>
            }


            <Fade in={show} timeout={{ enter: 300, exit: 500}} >
                <div className="dialog-box__backdrop"></div>
            </Fade>

        </>
    )
}

BottomSheet.propTypes = {
    name: PropTypes.string,
    phoneCode: PropTypes.bool,
    selected: PropTypes.string,
    close: PropTypes.func,
    getCountry: PropTypes.func,
    title: PropTypes.string,
}

BottomSheet.defaultProps = {
    name: "CountrySelector",
    phoneCode: false,
    selected: "BE"

}


export default BottomSheet